import { Camera, Settings2, Mail } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';

const STEPS = [
  {
    id: 'pick',
    icon: Camera,
    num: '01',
    title: 'Pick your experience',
    desc: 'Choose The Letterbox, The Voice Book, The PhotoBooth — or combine all three for the complete MISO setup.',
  },
  {
    id: 'setup',
    icon: Settings2,
    num: '02',
    title: 'We handle everything',
    desc: 'We arrive 90 minutes early, set up your custom backdrop, and stay for your entire event. You enjoy the party.',
  },
  {
    id: 'memories',
    icon: Mail,
    num: '03',
    title: 'Guests make memories',
    desc: 'Photos, voice messages, postcards. Every guest leaves with something beautiful to keep.',
  },
];

function StepCard({ step, delay }) {
  const reveal = useScrollReveal(delay);
  const Icon = step.icon;

  return (
    <div
      ref={reveal.ref}
      style={{ ...reveal.style }}
      data-testid={`step-${step.id}`}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '20px' }}>
        <div
          style={{
            width: '52px', height: '52px',
            borderRadius: '50%',
            backgroundColor: '#FAF5EF',
            border: '1px solid rgba(139,74,48,0.18)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Icon size={22} color="#B85C3A" strokeWidth={1.5} />
        </div>
        <span
          style={{
            fontFamily: 'Graphik, sans-serif',
            fontWeight: 800,
            fontSize: '36px',
            color: 'rgba(92,36,36,0.18)',
            lineHeight: 1,
          }}
        >
          {step.num}
        </span>
      </div>
      <h3 className="h3-miso" style={{ marginBottom: '12px', color: '#5C2424' }}>
        {step.title}
      </h3>
      <p className="body-miso" style={{ fontSize: '15px' }}>
        {step.desc}
      </p>
    </div>
  );
}

export default function HowItWorks() {
  const heading = useScrollReveal(0);
  const sub = useScrollReveal(0.1);

  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="section-pad"
      style={{ backgroundColor: '#F2EBE0' }}
    >
      <div className="container-miso">
        <div style={{ marginBottom: '64px', textAlign: 'center' }}>
          <span ref={heading.ref} style={heading.style} className="section-label">
            How it works
          </span>
          <h2 ref={sub.ref} style={{ ...sub.style }} className="h2-miso">
            Booked in 2 minutes.{' '}
            <span className="italic-accent" style={{ color: '#B85C3A' }}>Set up in 30.</span>
          </h2>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
            gap: '40px',
          }}
        >
          {STEPS.map((step, i) => (
            <StepCard key={step.id} step={step} delay={i * 0.15} />
          ))}
        </div>
      </div>
    </section>
  );
}
